/**
* LanguageRevisionInterfaceHelper.js
* 
* Created on 14-mei-2014, 15:43:48
*
* @author Ivo Swartjes for Ranj
**/
import { isUndefined, isArray, isString, isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";

export default class LanguageRevisionInterfaceHelper {
 
    constructor(stageRef) {
        this._stage = stageRef;
        this._currHighlightedTextFields = [];
        this._currMarkedTextFields = [];
    };
    
    highlightText(text) {
        this._highlightTextFields(this._currHighlightedTextFields, false);
        this._currHighlightedTextFields = [];
        if (isNull(text)) return;
        
        var textFields = [];
        this._findTextFieldsForText(this._stage, textFields, text);
        
        this._highlightTextFields(textFields, true);
    };
    
    updateText(oldText, newText, mark) {
        if (isNull(mark)) mark = false;

        var textFields = [];
        this._findTextFieldsForText(this._stage, textFields, oldText, false);
        this._changeTextFieldTexts(textFields, newText, mark);
    };
    
    clearMarkings() {
        for (var i = 0; i < this._currMarkedTextFields.length; i++) {
            var textField = this._currMarkedTextFields[i];
            
            this._mark(textField, false);
        }
    };
    
    // -------------------------------------------------
    
    _findTextFieldsForText(parent, collector, text, visibleOnly) {
        if (isNull(visibleOnly)) visibleOnly = true;
        
        var isStage = (parent instanceof createjs.Stage);
        
        for (var i = 0; i < parent.numChildren; i++) {
            var child = parent.getChildAt(i);
            
            if (child instanceof createjs.Container) {
                this._findTextFieldsForText(child, collector, text, visibleOnly);
            } else {
                if (child instanceof createjs.Text) {
                    if (child.text === text && (!visibleOnly || child.visible)) {
                        collector.push(child);
                    }
                }
            }
        }
    };
    
    _highlightTextFields(textFields, doHighlight) {
        for (var i = 0; i < textFields.length; i++) {
            var textField = textFields[i];
            if (isNull(textField)) continue;
            
            if (doHighlight) {
                // TODO: highlight text field somehow
            } else {
                // TODO: unhighlight text field
            }
        }        
    };
    
    _mark(textField, doMark) {
        if (isNull(doMark)) doMark = true;
        
        // TODO
    };
    
    _changeTextFieldTexts(textFields, newText, mark) {
        for (var i = 0; i < textFields.length; i++) {
            var textField = textFields[i];
            textField.text = newText;
            var curAlpha = textField.alpha;
            textField.alpha = 0;
            Tween.get(textField).to({alpha: curAlpha}, 500);
            
            this._mark(textField, mark);
        }
    };
}